




















































































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Mutation, State, Action, Getter } from 'vuex-class';
import ExternalWallet from '~/mixins/ExternalWallet';
import { IUser } from '~/store/profile/types';
import {
  IProviderOption,
  WalletConnectionErrorCode,
  IWalletConnectionError,
} from '~/store/web3_wallet/types';
import CaptureNameModal from '~/components/NewWallet/CaptureNameModal.vue';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import PrivateKeyButton from '~/components/Wallet/PrivateKeyButton.vue';
import AuthQuery from '~/mixins/AuthQuery';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { WalletConnectionError } from '~/utils/walletConnectionError';

@Component({
  components: { CaptureNameModal, TwoFactorAuthInputPrompt, PrivateKeyButton },
})
export default class ConnectWallet extends Mixins(ExternalWallet, AuthQuery) {
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly hideWelcomeHeading!: boolean;

  @Getter('w3wConnectionActive', { namespace: 'web3Wallet' })
  readonly w3wConnectionActive!: boolean;

  @Action('promptToRegister')
  private promptToRegister!: (options?: {
    redirectAfterLoginPath?: string;
  }) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation('setWalletConnectionError', { namespace: 'web3Wallet' })
  setWalletConnectionError!: (payload?: IWalletConnectionError | null) => void;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => void;

  savingName = false;
  shouldShowInstallModal = false;
  showGalaWalletHolderError = false;
  selectedProviderOption: null | IProviderOption = null;
  redirectRoute = '/';
  dappPath = window.location.href.toString().replace(/(http[s]*:\/\/)/, '');
  isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  walletConnectionErrorCode = WalletConnectionErrorCode;

  get heading() {
    return this.w3wConnectionActive
      ? this.$t('components.wallet.connectWeb3Wallet.heading.connected')
      : this.walletConnectionError
      ? this.walletConnectionError.shortMessage ||
        this.walletConnectionError.message
      : this.$t('components.wallet.connectWeb3Wallet.heading.notConnected');
  }

  get welcome() {
    return this.w3wConnectionActive || this.walletConnectionError
      ? ''
      : this.$t('common.misc.welcome');
  }

  get description() {
    return this.w3wConnectionActive
      ? ''
      : this.$t('components.wallet.connectWeb3Wallet.body');
  }

  get missingFullName() {
    const { firstName, lastName, fullNameNotProvided } = this.currentUser;
    const regex = /gamer/i;
    return (
      fullNameNotProvided && (regex.test(firstName) || regex.test(lastName))
    );
  }

  get missingProviderLink() {
    const selectedProviderOption = this.connectedExternalWallet.walletProvider
      ? this.providerOptions.find(
          option =>
            option.label === this.connectedExternalWallet.walletProvider,
        )
      : this.selectedProviderOption;

    if (selectedProviderOption) {
      return this.isMobile
        ? selectedProviderOption.missingProviderMobileLink(this.dappPath)
        : selectedProviderOption.missingProviderDesktopLink;
    }
    return '';
  }

  created() {
    if (this.$router.currentRoute?.query?.item) {
      this.redirectRoute = `/games/buy-item/${this.$router.currentRoute.query.item}`;
    }
  }

  async handleFullNameSubmitted(firstName: string, lastName: string) {
    this.savingName = true;
    await this.doAuthQuery(async totpToken => {
      this.updateUser({
        firstName,
        lastName,
        ignoreSnackbar: true,
        rethrowErrorCodes: twoFaErrorCodes,
        totpToken,
      });
    }, TwoFaCheckpoint.accountModifications);
    this.savingName = false;
  }

  async handleMissingProvider() {
    if (this.selectedProviderOption) {
      if (this.isMobile && !window.location.href.includes('wb=true')) {
        // This might not work on all mobile devices for all web3 wallet apps. Some require the deep link to be initiated by a user action like a click. This link is provided in the install modal that gets shown
        window.open(
          this.selectedProviderOption.missingProviderMobileLink(this.dappPath),
          '_blank',
        );
      }
      this.shouldShowInstallModal = true;
    }
  }

  async onConnectClick(option: IProviderOption) {
    const passedAuthValidation = await this.validateAuthRequirement();
    if (!passedAuthValidation) {
      return;
    }
    try {
      this.selectedProviderOption = option;
      const { success, message, cause } = await this.connect(
        {
          label: option.label,
          connectToUser: true,
        },
        this.doAuthQuery,
      );

      if (success) {
        this.selectedProviderOption = null;
      } else {
        throw new WalletConnectionError(message || '', cause);
      }
    } catch (err) {
      let message: string = (err as Error).message;
      const cause = (err as { cause?: WalletConnectionErrorCode }).cause;

      if (cause === this.walletConnectionErrorCode.MISSING_PROVIDER) {
        this.handleMissingProvider();
      } else {
        if (cause === this.walletConnectionErrorCode.UNKNOWN) {
          message = this.$t(
            'components.wallet.connectWeb3Wallet.errorMessages.defaultErrorMsg',
            {
              provider: this.capitalize(this.selectedProviderOption!.label),
            },
          ) as string;
        }
        if (
          this.walletExists &&
          message
            .toLowerCase()
            .includes(
              'the ethereum address of connecting wallet must match the gala wallet when connecting for the first time',
            )
        ) {
          this.showGalaWalletHolderError = true;
        }
        this.updateSnackbarErrorText(message);
        this.toggleErrorSnackbar();
        this.selectedProviderOption = null;
      }
    }
  }

  handleConnectClick() {
    this.connect(
      {
        label: this.connectedExternalWallet.walletProvider,
        connectToUser: false,
      },
      this.doAuthQuery,
    );
  }

  moveOn() {
    this.$router.push(this.redirectRoute);
  }

  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  async validateAuthRequirement() {
    if (
      // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
      !this.$auth.strategy.token.get()
    ) {
      if (this.loggedIn) {
        window.location.assign(
          `${window.location.origin}${this.$route.path}?register=1`,
        );
      } else {
        this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
      }
      return false;
    }
    return true;
  }

  @Watch('shouldShowInstallModal')
  onShouldShowInstallModalChange(show: boolean, oldVal: boolean) {
    if (oldVal && !show) {
      this.selectedProviderOption = null;
      this.setWalletConnectionError(null);
    }
  }
}
